export const MERIDIEM_AM = "AM";
export const MERIDIEM_PM = "PM";
export const START_MINUTES = 0;
export const END_MINUTES = 1440;
export const DEFAULT_INTERVAL = 15;
export const DEFAULT_VALUE = "12:00 AM";

export const convertMinsToHoursLabel = (
  mins,
  use24Hours = false,
  addMeridiem = false
) => {
  let h = Math.floor(mins / 60);
  const m = mins % 60;

  if (!use24Hours) {
    if (h === 0) {
      h = 12;
    } else if (h > 12) {
      h -= 12;
    }
  }

  const hDisplay = h > 9 ? `${h}:` : `0${h}:`;
  const mDisplay = m > 9 ? m : `0${m}`;
  let final = hDisplay + mDisplay;

  if (!use24Hours && addMeridiem) {
    final = mins >= 720 ? `${final} PM` : `${final} AM`;
  }
  return final;
};

export const createRangeWithInterval = (start, end, interval = 1) => {
  const arr = [];
  for (let i = start; i <= end; i += interval) {
    arr.push(i);
  }
  return arr.splice(0, arr.length - 1);
};

export const get12HoursOptions = interval => meridiem => {
  return createRangeWithInterval(START_MINUTES, END_MINUTES / 2, interval).map(
    value => ({
      label: convertMinsToHoursLabel(value, false),
      value: meridiem === "PM" ? value + END_MINUTES / 2 : value
    })
  );
};

export const get24HoursOptions = interval => {
  return createRangeWithInterval(START_MINUTES, END_MINUTES, interval).map(
    value => ({
      label: convertMinsToHoursLabel(value, true),
      value
    })
  );
};

export const convertHoursLabelToMinutes = label => {
  const arr = label.split(":");
  return +arr[0] * 60 + +arr[1];
};

export const validateHourForMeridiem = userHours => {
  if (userHours > 12) {
    return false;
  }
  return true;
};

export const parseValue = (
  value,
  use24Hours = false,
  throwException = true
) => {
  const regex = /^([01]\d|2[0-3]):?([0-5]\d)(\s*(am|pm|AM|PM))?$/;
  let meridiem = null;

  // If the format is not accepted at all (either with am|pm or without am|pm)
  if (!regex.test(value)) {
    if (throwException) {
      throw new Error("Invalid time to parse");
    }
    return null;
  }

  // If use24Hours is enabled, accept the input only without am|pm
  if (use24Hours && /am|AM|pm|PM/.test(value)) {
    if (throwException) {
      throw new Error(
        "Meridiem (AM|PM) are not accepted in case of 24 hours timepicker"
      );
    } else {
      return null;
    }
  }

  // If use24Hours is disabled, accept the input only with am|pm
  if (!use24Hours && !/am|AM|pm|PM/.test(value)) {
    if (throwException) {
      throw new Error(
        "Meridiem (AM|PM) are required in case of 12 hours timepicker"
      );
    } else {
      return null;
    }
  }

  // Parse user provided input
  const arr = value.split(":");
  const userHours = Number(arr[0]);
  const userMins = parseInt(arr[1], 10);
  let selectedMinutes = userHours * 60 + userMins;

  // Extract correct meridiem value (AM or PM)
  if (use24Hours) {
    if (selectedMinutes >= 720) {
      meridiem = "PM";
    } else {
      meridiem = "AM";
    }
  } else {
    if (!validateHourForMeridiem(userHours)) {
      if (throwException) {
        throw new Error("Meridiem (AM|PM) can only be given to 01 - 12 hours");
      } else {
        return null;
      }
    }
    if (/am|AM/.test(value)) {
      meridiem = "AM";
      selectedMinutes = userHours === 12 ? userMins : userHours * 60 + userMins;
    } else if (/pm|PM/.test(value)) {
      meridiem = "PM";
      selectedMinutes =
        userHours === 12 ? userMins + 720 : selectedMinutes + 720;
    }
  }

  return {
    meridiem,
    selectedTime: {
      label: convertMinsToHoursLabel(selectedMinutes, use24Hours),
      value: selectedMinutes
    }
  };
};
